import { InstrumentValuesReportViewModel } from '@dynamik/common/clients/reporting-clients';
import { CustomerService, IApplicationFilter, PortfolioReportCache, property, widget, WidgetPropertyType } from '@dynamik/common';
import { BindingEngine } from 'aurelia-binding';
import { WidgetBase } from '@dynamik/common';
import { customElement } from 'aurelia-templating';

export enum TotalProfitLossWidgetStartFrom {
  ToDateYearStart = 1,
  FromDate = 2
}

@customElement('total-profit-loss-light-widget')
@widget({ name: 'Total profit/loss', canUseInReport: true, canUseInDashboard: true, description: 'Displays the name of the customer', defaultWidth: 27, defaultHeight: 12 })
export class TotalProfitLossWidget extends WidgetBase {
  constructor(element: Element, customerService: CustomerService, private portfolioReportCache: PortfolioReportCache, bindingEngine: BindingEngine) {
    super(element, bindingEngine, customerService);
    this.title = 'Total Profit/Loss:';
    this.titleFontSize = 14;
  }

  profitLossTotal: number;

  @property('Data', undefined, WidgetPropertyType.List, [
    { value: TotalProfitLossWidgetStartFrom.ToDateYearStart, label: '"To" date year start' },
    { value: TotalProfitLossWidgetStartFrom.FromDate, label: '"From" date' }
  ])
  startFrom: TotalProfitLossWidgetStartFrom = TotalProfitLossWidgetStartFrom.ToDateYearStart;

  @property('Data')
  precision?: number = 2;

  @property('Text')
  font?: string;

  @property('Text')
  fontSize?: number = 18;

  @property('Text')
  color?: string;

  @property('Text', 'Alignment', WidgetPropertyType.List, [{ value: 'left', label: 'Left' }, { value: 'center', label: 'Center' }, { value: 'right', label: 'Right' }])
  textAlign?: string;

  protected async loadData(filter: IApplicationFilter) {
    const dateFromStr = this.startFrom === TotalProfitLossWidgetStartFrom.FromDate ? filter.dates.fromStr : undefined;
    return this.portfolioReportCache.instrumentValues(filter.customer.companyId, dateFromStr, filter.dates.toStr, undefined, undefined, false);
  }

  protected async setData(data: InstrumentValuesReportViewModel[]): Promise<void> {
    this.profitLossTotal = this.startFrom === TotalProfitLossWidgetStartFrom.FromDate
      ? data.reduce((a, b) => a + b.profitLossChangeInPeriod, 0)
      : data.reduce((a, b) => a + b.profitLossChangeYearToDate, 0);
  }

  override configChanged(key: keyof TotalProfitLossWidget) {
    switch (key) {
      default:
        this.refresh$.next(undefined);
        break;
    }
  }
}
